import { AfterViewInit, ChangeDetectionStrategy, Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { IGenerateReport } from './generate-report.types';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LookupService } from 'app/core/common/services/lookup.service';
import { InwardsService } from 'app/modules/admin/transactions/inwards/inwards.service';
import { AlertMessageService } from 'app/core/common/alert.message.service';
import { CommonDropDown } from 'app/core/common/types/dropdown.types';
import { InwardReport } from 'app/modules/admin/transactions/inwards/reports.types';
import { Inward } from 'app/modules/admin/transactions/inwards/inwards.types';
import { TemplateType, TemplateTypeData } from 'app/core/common/enums/templateType';
import { ReportsService } from 'app/modules/admin/transactions/inwards/reports.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import moment from 'moment';

@Component({
    selector: 'app-generate-report',
    templateUrl: './generate-report.component.html',
    styleUrls: ['./generate-report.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GenerateReportComponent implements OnInit, AfterViewInit {
    dialogTitle = `Generate Report`;
    generateReportForm: FormGroup;
    generateReport: IGenerateReport;
    report: InwardReport;
    alert: any;
    googleDrivePath: string = ""
    reportType: string = ''
    // generateReport$: Observable<IGenerateReport[]>;
    templates: CommonDropDown[];
    filteredTemplates: CommonDropDown[];

    bankId: number;
    templateType: string;
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    constructor(
        @Inject(MAT_DIALOG_DATA) private _data,
        private _matDialogRef: MatDialogRef<GenerateReportComponent>,
        private _formBuilder: FormBuilder,
        private _lookupService: LookupService,
        private _alertMessage: AlertMessageService,
        private _inwardsService: InwardsService,
        private _matDialog: MatDialog,
        private _reportService: ReportsService

    ) {
        this.googleDrivePath = this._data.googleDrivePath
        this.bankId = this._data.bankId
        this.templateType = this._data.templateType
        this.generateReportForm = this._formBuilder.group({
            templateId: ['', [Validators.required]],
            note: [''],
            reportId: [this._data.reportId],
            isDownload: [''],
            templateType: [this.templateType],
            bankId: [this.bankId],
            reportType: [this.reportType],
            //loanDepartmentId: [this._data.loanDepartmentId]
        });
        this._reportService.getReport(this._data.reportId).subscribe();
    }

    ngAfterViewInit(): void {
        this.onCheckBoxSelection();
        this._reportService.report$.pipe(takeUntil(this._unsubscribeAll))
            .subscribe((report: InwardReport) => {
                this.report = report
                this.reportType = report?.reportType
                this.generateReportForm.controls['reportType'].patchValue(this.reportType)
            });
    }

    ngOnInit(): void {

    }

    onCheckBoxSelection() {
        const val = this.generateReportForm.getRawValue();
        this._lookupService.getTemplates(null, val.bankId, val.templateType, val.reportType).subscribe((res) => {
            this.templates = res;
            this.filteredTemplates = this.templates;
        });
    }

    updateFormControl(controlName: string, value: any) {
        this.generateReportForm.controls[controlName].setValue(value);
        this.onCheckBoxSelection();
    }

    onCheckBoxSelectionBank(event) {
        const value = event.checked ? this.bankId : null;
        this.updateFormControl("bankId", value);
    }

    onCheckBoxSelectionReportType(event) {
        const value = event.checked ? this.reportType : null;
        this.updateFormControl("reportType", value);
    }

    onFileDownload(isDownload: boolean) {
        let data = this.generateReportForm.getRawValue();
        data.isDownload = isDownload;
        return this._inwardsService.generateReport(data).subscribe((response) => {
            if (response.body.type != 'application/json') {
                var fileName = this.getFileName(response);
                this.generateReportdownloadFile(response, `${fileName}.docx`);
            }
            else {
                this._alertMessage.success("upload successfully")
                this._matDialogRef.close();
            }
        });
    }

    async generateReportdownloadFile(data: any, fileName) {
        const downloadedFile = new Blob([data.body], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
        const link = document.createElement('a');
        link.setAttribute('style', 'display:none;');
        document.body.appendChild(link);
        link.download = fileName;
        link.href = URL.createObjectURL(downloadedFile);
        link.target = '_blank';
        link.click();
        document.body.removeChild(link);
        this._matDialogRef.close();
    }

    onClose(): void {
        this._matDialogRef.close();
    }

    private _templatesfilter(name: string): CommonDropDown[] {
        const filterValue = name.toString().toLowerCase();

        return this.templates.filter(option => option.name.toLowerCase().includes(filterValue));
    }
    onTemplateSearch(value) {
        this.filteredTemplates = this._templatesfilter(value);
    }

    getFileName(response) {
        const contentDisposition = response.headers.get('Content-Disposition');

        let filename = `Report_${moment().format("YYYYMMDDHHmmss")}`; // Default fallback filename

        if (contentDisposition) {
            const match = contentDisposition.match(/filename="?([^"]+)"?/);
            if (match && match[1]) {
                filename = decodeURIComponent(match[1]); // Decode URL-encoded filename
            }
        }

        return filename
    }
}
